module.exports = __webpack_public_path__ + "img/People Manager.91f0853b.svg";